import React from 'react'
import queryString from 'query-string'
import { IconX, IconCheck } from '@tabler/icons-react'

import { apiService } from '@/api'
import { ButtonAndFormModal } from '@/components/layout/modals/ButtonAndFormModal'
import { Pill } from '@/components/pills/Pill'

const CLIENT_ID = process.env.SALESFORCE_CLIENT_ID || 'salesforce_client_id'

export const ManageSalesforceIntegrationButton = ({
  organizationId,
  salesforceIntegrationEnabled = false,
}) => {
  const baseUrl = 'https://login.salesforce.com/services/oauth2/authorize'
  const params = queryString.stringify({
    response_type: 'code',
    client_id: CLIENT_ID,
    redirect_uri: `${apiService.auth}/salesforce/redirect`,
    state: organizationId,
  })

  return (
    <ButtonAndFormModal
      buttonLabel="Manage Salesforce Integration"
      modalTitle="Manage Salesforce Integration"
      modalId="manage-salesforce-integration"
      modalProps={{ size: 'tiny' }}
      buttonProps={{ primary: true }}
      modalContent={
        <div className="flex-column flex-center flex-align-center gap">
          {salesforceIntegrationEnabled ? (
            <Pill outline success icon={<IconCheck />}>
              Connected
            </Pill>
          ) : (
            <Pill outline icon={<IconX />}>
              Not Connected
            </Pill>
          )}
          <a
            target="_blank"
            rel="noreferrer"
            className="balto-button brand"
            href={`${baseUrl}?${params}`}
            data-testid="salesforce-integration-link"
          >
            Connect to Salesforce
          </a>
        </div>
      }
    />
  )
}
